function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "q3nA",
  x1: 0.293,
  y1: 0.336,
  x2: 0.801,
  y2: 0.975,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9ad8ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9ca4ff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.23 5.586)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 48,
  transform: "translate(-2.23 -5.586)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.987,40.909l-9.628,5.062a2.357,2.357,0,0,1-3.42-2.485l1.839-10.721L7.989,25.172A2.357,2.357,0,0,1,9.3,21.152L20.06,19.587l4.814-9.754a2.357,2.357,0,0,1,4.228,0l4.814,9.754L44.68,21.152a2.357,2.357,0,0,1,1.306,4.021L38.2,32.765l1.839,10.721a2.357,2.357,0,0,1-3.42,2.485Z",
  transform: "translate(-7.277 -8.904)",
  fillRule: "evenodd",
  fill: "url(#q3nA)"
}));

function SvgStarActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarActive);
export default __webpack_public_path__ + "static/media/star-active.afe06258.svg";
export { ForwardRef as ReactComponent };